module.exports = __webpack_public_path__ + "img/live_advance.4e1a01bb.png";